import React from "react";
import { Col, Container, Row } from "reactstrap";

export const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid>
          <Row>
            <Col sm={6}>{new Date().getFullYear()} © The Q </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};
